module.exports = __webpack_public_path__ + "static/media/BankAccounts.0ad74244.png";